<template>
  <div>
    <och-alert v-if="showWarning">
      Changing from "Select Multiple Items" to "Select Item" will only save one
      item from the previous selection after next save. This could result in
      losing data from the previous selection.
    </och-alert>
    <v-autocomplete
      :disabled="disabledOverride"
      :item-text="optionConfig.label"
      :item-value="optionConfig.entityAttributeName"
      :items="itemList"
      :rules="ruleList"
      outlined
      v-model="value"
    ></v-autocomplete>
  </div>
</template>

<script>
import formElementMixin from "./formElementMixin";
import OchAlert from "@/components/OchAlert";
import selectReferenceMixin from "./selectReferenceMixin";

export default {
  components: {
    OchAlert,
  },
  computed: {
    disabledOverride() {
      const { mode, value } = this;

      // Always available on create
      if (mode === "create") {
        return false;
      }

      // If previously set a "Select" elementType, then enable updates
      if (value === "SelectFk" || value === "SelectFkMultiple") {
        return false;
      }

      return true;
    },
    itemList() {
      const { mode } = this;

      const baseList = this.$store.state[this.optionConfig.entityName].list;

      // Disable all but "Select" options if in update mode
      let itemList = baseList.map(item => {
        // Early return if in create
        if (mode === "create") {
          item.disabled = false;
          return item;
        }

        // Early return if "Select" option
        const { name } = item;
        if (name === "SelectFk" || name === "SelectFkMultiple") {
          return item;
        }

        item.disabled = true;

        return item;
      });

      if (!this.optionConfig.filterIf) {
        return itemList;
      }

      itemList = itemList.filter(item => item[this.optionConfig.filterIf]);

      return itemList;
    },
    showWarning() {
      const { previousValue, value } = this;

      if (previousValue === "SelectFkMultiple" && value === "SelectFk") {
        return true;
      }

      return false;
    },
  },
  created() {
    const { value } = this;

    this.previousValue = value;
  },
  data() {
    return {
      previousValue: undefined,
    };
  },
  mixins: [formElementMixin, selectReferenceMixin],
  watch: {
    "attributeMap.elementType": function (newValue, oldValue) {
      // This is needed when attributeMap.elementType isn't set during created
      if (typeof oldValue === "undefined") {
        this.previousValue = newValue;
      }
    },
  },
};
</script>
